import api from "@/lib/api";

export async function startCheckout(lookupKey) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
  });
  if (!data?.checkout_url) throw new Error("No checkout URL");
  window.location.href = data.checkout_url;
}
